import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-[#0c1427] p-5 rounded-md shadow-md flex flex-col min-h-[450px]" }
const _hoisted_2 = { class: "text-black dark:text-white font-semibold mb-6 text-center text-xl" }
const _hoisted_3 = { class: "mb-5 flex-grow" }
const _hoisted_4 = {
  key: 0,
  class: "text-gray-500 italic"
}
const _hoisted_5 = { class: "space-y-2 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "text-black dark:text-white" }
const _hoisted_8 = {
  key: 0,
  class: "ml-2 text-xs bg-red-500 text-white px-2 py-0.5 rounded"
}
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex justify-between flex-nowrap gap-2 w-full mt-auto" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "text-sm text-red-500 mt-2 text-center" }
const _hoisted_15 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_16 = { class: "bg-white dark:bg-[#0c1427] p-6 rounded-md shadow-lg w-full max-w-md relative z-10" }
const _hoisted_17 = { class: "text-xl font-bold mb-4 text-black dark:text-white" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "mb-6" }
const _hoisted_22 = { class: "flex items-center space-x-2 cursor-pointer" }
const _hoisted_23 = { class: "text-gray-700 dark:text-gray-300" }
const _hoisted_24 = { class: "flex justify-end space-x-3" }
const _hoisted_25 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_26 = { class: "bg-white dark:bg-[#0c1427] p-6 rounded-md shadow-lg w-full max-w-md relative z-10" }
const _hoisted_27 = { class: "text-xl font-bold mb-4 text-black dark:text-white" }
const _hoisted_28 = { class: "mb-6 text-gray-700 dark:text-gray-300" }
const _hoisted_29 = { class: "flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.directT('settings.customersSettings.customFields.management')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.fields.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.directT('settings.customersSettings.customFields.noFields')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "flex items-center justify-between bg-white dark:bg-[#0c1427] p-3 rounded border border-gray-200 dark:border-[#1c2b50]"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(field.field), 1),
              (field.isrequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Required "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.editField(index)),
                class: "text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, "edit", -1)
              ]), 8, _hoisted_10),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.confirmDeleteField(index)),
                class: "text-red-500 hover:text-red-700"
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, "delete", -1)
              ]), 8, _hoisted_11)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewField && _ctx.addNewField(...args))),
        class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md flex items-center justify-center whitespace-nowrap min-w-[120px]"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.directT('settings.customersSettings.customFields.addField')), 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveFields && _ctx.saveFields(...args))),
        class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md whitespace-nowrap min-w-[120px] flex items-center justify-center",
        disabled: _ctx.saving
      }, _toDisplayString(_ctx.saving ? _ctx.directT('settings.customersSettings.customFields.saving') : _ctx.directT('settings.customersSettings.customFields.saveChanges')), 9, _hoisted_13)
    ]),
    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.directT('settings.customersSettings.customFields.important')), 1),
    (_ctx.showFieldModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeFieldModal && _ctx.closeFieldModal(...args)))
          }),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.editingFieldIndex === -1 ? _ctx.directT('settings.customersSettings.customFields.addCustomFieldTitle') : _ctx.directT('settings.customersSettings.customFields.editCustomFieldTitle')), 1),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.directT('settings.customersSettings.customFields.fieldName')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingField.field) = $event)),
                type: "text",
                class: "h-[45px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-4 block w-full outline-0 focus:border-primary-500",
                placeholder: _ctx.directT('settings.customersSettings.customFields.fieldNamePlaceholder')
              }, null, 8, _hoisted_20), [
                [_vModelText, _ctx.editingField.field]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingField.isrequired) = $event)),
                  type: "checkbox",
                  class: "form-checkbox h-5 w-5 text-primary-500 rounded border-gray-300 focus:ring-primary-500"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.editingField.isrequired]
                ]),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.directT('settings.customersSettings.customFields.requiredField')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeFieldModal && _ctx.closeFieldModal(...args))),
                class: "px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-white rounded-md hover:bg-gray-50 dark:hover:bg-[#172036]"
              }, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.cancel')), 1),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveField && _ctx.saveField(...args))),
                class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md"
              }, _toDisplayString(_ctx.editingFieldIndex === -1 ? _ctx.directT('settings.customersSettings.statusManagement.add') : _ctx.directT('settings.customersSettings.statusManagement.update')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("h5", _hoisted_27, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.confirmDeleteTitle')), 1),
            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.directT('settings.customersSettings.customFields.deleteFieldConfirmation')), 1),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-white rounded-md hover:bg-gray-50 dark:hover:bg-[#172036]"
              }, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.cancel')), 1),
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deleteField && _ctx.deleteField(...args))),
                class: "px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md"
              }, _toDisplayString(_ctx.directT('settings.customersSettings.statusManagement.delete')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}